import React from "react";
import { ICommentFieldsLegacyFragment } from "~/lib/queries/fragments/__generated__/CommentFields.generated";
import { ICommentTargetType } from "~/types/types";
import { useSelfie } from "~/components/auth/Auth";
import Comment from "~/components/comment/Comment";
import { SingleReplyContextProvider } from "~/components/comment/SingleReplyContext";

interface ICommentsProps {
  targetId: string;
  targetType: ICommentTargetType;
  comments: ICommentFieldsLegacyFragment[];
  preview?: boolean;
}

export default function Comments({ targetId, targetType, comments, preview = false }: ICommentsProps) {
  const user = useSelfie();

  if (!user) {
    return null;
  }

  return (
    <div
      css={{
        display: "grid",
        gridRowGap: 20,
      }}
    >
      <SingleReplyContextProvider>
        {comments.map((comment) => {
          return (
            <Comment
              key={comment._id}
              targetId={targetId}
              targetType={targetType}
              comment={comment}
              preview={preview}
            />
          );
        })}
      </SingleReplyContextProvider>
    </div>
  );
}
